import {createContext, useContext, useState} from "react";

export const FilesContext = createContext([]);

export const useFilesCtx = () => useContext(FilesContext);

export default ({ children }) => {
  const [files, setFiles] = useState([]);

  const addFiles = (newFiles) => setFiles(files => [...files, newFiles]);

  return (
    <FilesContext.Provider value={[files, addFiles]}>
      {children}
    </FilesContext.Provider>
  );
}
